// @ts-nocheck
import { useFormik } from "formik";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { formikValidation, formikinitialvalues } from "../../../../../CommonFunction/common";
import Input from "../../../Input/Input";
import "./LRPickupUpdationFreightChargesForm.scss";
import { calculateTotal, CheckfieldExistornot, CheckTypeofInput, updateSingleField, validationAdditional } from "../../../FormInputSectionComponent/formUtils";
import { Formik_Vschema } from "../../../FormInputSectionComponent/Validation";
import { parseFormulaOnly, parseTheAdditionInfo } from "../../../../CommonFunction/parseTheAdditionInfo";

const LRPickupUpdationFreightChargesForm = ({
  inputfields,
  Type,
  TotalKeyName = "Total",
  TypeOfPortal,
  formkey = "",
  FormData,
  formRef,
  onhandleFormikChange,
  handleErrorsChange,
  FovPercentage,
  setFovPercentage,
  GSTPercentage,
}) => {
  const [fields, setfields] = useState(inputfields);
  const [userType, setUserType] = useState({});
  const FormDataFromRedux = useSelector((store: any) => store?.FormDataReducer);
  const dispatch = useDispatch();
  const prevObjRef = useRef();
  const prevErrorsRef = useRef();


  const formik = useFormik({
    initialValues: formikinitialvalues(inputfields),
    validationSchema: Formik_Vschema(fields),
    enableReinitialize: true,
    validateOnChange: true,

    onSubmit: (values, { resetForm }) => { },
  });

  useEffect(() => {
    setfields(parseFormulaOnly(inputfields));
  }, [inputfields]);

  useEffect(() => {
    if (formRef && Type) {
      formRef.current[Type] = {
        submitForm: formik.submitForm,
        resetForm: (InpType) => {
          if (InpType) {
            const filteredFields = CheckTypeofInput(fields, InpType);

            filteredFields?.forEach((field) => {
              if (field?.name) {
                formRef.current?.[Type]?.updateSingleField(field.name, null);
              }
            });
          } else formik.resetForm();
        },
        updateForm: (newValues) => {
          let arr = [];
          for (let a = 0; a < fields?.length; a++) {
            if (fields[a].name === "Sidebyside") {
              for (let b = 0; b < fields[a].Subfields.length; b++) {
                const subfield = fields[a].Subfields[b];
                let fieldValue = newValues[subfield.name] || (subfield.type === "checkbox" ? false : null);
                arr.push({ [subfield.name]: fieldValue });
              }
            } else {
              let fieldValue = newValues[fields[a].name] ?? (fields[a].type === "checkbox" ? false : null);
              arr.push({ [fields[a].name]: fieldValue });
            }
          }

          const obj = arr.reduce((acc, cur) => ({ ...acc, ...cur }), {});
          formik.setValues({ ...formik.values, ...obj });
        },
        updateSingleField: (name, value) => {
          let fieldExists = CheckfieldExistornot(fields, name);

          if (fieldExists) {
            formik.setFieldValue(name, value);
          } else {
            console.warn(`Field with name "${name}" does not exist in the fields array.`);
          }
        },

        formclearFields: (InpType) => { },
        values: formik.values,
      };
    }

    return () => { };
  }, [formRef, Type, formik]);

  useEffect(() => {
    if (prevErrorsRef.current !== formik.errors) {
      const Err_Type = Type;
      const errors = { [Err_Type]: formik.errors };
      handleErrorsChange(errors);
      prevErrorsRef.current = formik.errors;
    }
  }, [formik.errors, handleErrorsChange, Type, formik.values]);

  useEffect(() => {
    const values = { [Type]: formik.values };
    onhandleFormikChange(formik.values);
    formik.validateForm();
  }, [formik.values, Type]);



  useEffect(() => {
    if (TotalKeyName === "Transporter_Sub_Total") {
      let total = 0;
      if (FormData?.Transporter_Freight_On === "Weight") {
        total = Number(FormData?.Transporter_Loading_Weight) * Number(FormData?.Transporter_Rate);
      } else if (FormData?.Transporter_Freight_On === "Fixed") {
        total = Number(FormData?.Transporter_Rate);
      }

      updateSingleField(formRef, "Transporter_Freight_Amount", total ? Number(total.toFixed(2)) : 0);
    }
  }, [FormData?.Transporter_Loading_Weight, FormData?.Transporter_Rate, FormData?.Transporter_Freight_On]);

  useEffect(() => {
    if (TotalKeyName === "Bill_Party_Sub_Total") {
      let total = 0;
      if (FormData?.Bill_Party_Freight_On === "Weight") {
        total = Number(FormData?.Bill_Party_Loading_Weight) * Number(FormData?.Bill_Party_Rate);
      } else if (FormData?.Bill_Party_Freight_On === "Fixed") {
        total = Number(FormData?.Bill_Party_Rate);
      }

      updateSingleField(formRef, "Bill_Party_Freight_Amount", total ? Number(total.toFixed(2)) : 0);
    }
  }, [FormData?.Bill_Party_Loading_Weight, FormData?.Bill_Party_Rate, FormData?.Bill_Party_Freight_On]);

  useEffect(() => {
    let total = 0;
    if (FormData?.Freight_On === "Weight") {
      total = Number(FormData?.Total_Weight) * Number(FormData?.Rate);
    } else if (FormData?.Freight_On === "Quantity") {
      total = Number(FormData?.Total_Quantity) * Number(FormData?.Rate);
    } else if (FormData?.Freight_On === "Per Article") {
      total = Number(FormData?.Total_Article) * Number(FormData?.Rate);
    } else if (FormData?.Freight_On === "Per KM") {
      total = Number(FormData?.Total_KM) * Number(FormData?.Rate);
    } else if (FormData?.Freight_On === "Fixed") {
      total = Number(FormData?.Rate);
    }
    updateSingleField(formRef, "Freight_Amount", total ? total.toFixed(2) : 0);
  }, [FormData?.Freight_On, FormData?.Rate, FormData?.Total_Quantity, FormData?.Total_Weight, FormData?.Total_KM]);

  const determineVisibility = (field) => {
    if (field.header && field.name === "Pincode") {
      setUserType(field.header);
    }

    if (field.dependOn) {
      const { section, name, visibleOn } = field.dependOn;

      if (formRef.current[section]?.values[name] === visibleOn) {
        return true;
      } else if (formRef.current[section]?.values[name]) {
        if (formik.errors?.[field.name]) {
          delete formik.errors[field.name];
        }
        console.log(formik.errors, "formik.errorsformik.errors1");
        let key = field.name;
        if (formik.values[key]) {
          formik.setFieldValue(key, "");
          if (field?.type === "InputDropForQuery") {
            dispatch({
              type: "StoreMasterData",
              payload: {
                formkey: formkey,
                data: {
                  [field.name]: "",
                },
              },
            });
          }
        }
        return false;
      } else if (FormData?.[name] === visibleOn) {
        return true;
      }
      if (formik.errors?.[field.name]) {
        delete formik.errors[field.name];
      }
      return false;
    }

    return true; // Fields without a dependOn property are always visible
  };
  const determineDisability = (field) => {
    if (field?.disableDependOn) {
      const { section, name, disableOn, value, disableOnValue } = field.disableDependOn;
      const dependentSection =
        FormDataFromRedux?.MasterData?.[formkey]?.[name]?.[disableOn] || formRef.current?.[section]?.values[name];
      if (dependentSection !== null && dependentSection !== undefined && disableOnValue !== dependentSection) {
        return { ...field, disabled: false };
      } else {
        let key = field.name;
        if (value && formik.values[key] !== value) {
          formik.setFieldValue(key, value);
        }

        return { ...field, disabled: true };
      }
    }
    return field;
  };

  useEffect(() => {
    if (FormData) {
      let obj = FormData;
      const prevObj = prevObjRef.current;
      let changedKey = false;

      if (prevObj) {
        for (const key in obj) {
          if (obj[key] !== prevObj[key] && !(Number.isNaN(obj[key]) && Number.isNaN(prevObj[key]))) {
            if (key !== TotalKeyName) {
              changedKey = true;
            }
          }
        }
      }

      if (changedKey) {
        let total = calculateTotal(fields[fields?.length - 1]?.formula, FormData);

        updateSingleField(formRef, TotalKeyName, Number(total?.toFixed(2)));
      }
      prevObjRef.current = obj;
    }
  }, [FormData]);

  return (
    <div className="freight-charges-container">
      {fields?.length && fields.map((e, index) => {
        if (!determineVisibility(e)) {
          return null;
        }
        return (
          <>
            <div className="freight-charges-input" key={index}>
              <label>{e.label}</label>
              {(e.name === "FOV" || e.name === "FSC") && (
                <>
                  <input
                    className="taxInput"
                    disabled={e.name === "FSC" ? true : false}
                    value={e.name === "FOV" ? FovPercentage : 0}
                    onChange={(el) => {
                      if (e.name === "FOV") {
                        setFovPercentage(el.target.value);
                      }
                    }}
                  />
                  %
                </>
              )}

              <Input
                EMTQuery=""
                InputConfig={e}
                JurnalDropdown=""
                Section_Type=""
                disabled={e.disabled}
                transactions=""
                PaymentProcess=""
                checked=""
                TypeOfPortal={TypeOfPortal}
                name={e.name}
                value={formik.values?.[e.name]}
                label={e.label}
                className={"inputwidthAddload"}
                type={e.type}
                modalform={true}
                handleInputChange={(evt) => {
                  formik.handleChange(evt);
                }}
                // handelformikdata={handelformikdata}
                dropdowndata={e.dropdowncontent}
                handleBlur={formik.handleBlur}
                touched={formik.touched[e.name]}
                error={formik.errors[e.name]}
                max={e.max ? e.max : undefined}
                notSearchable={e.name === "From_City" || e.name === "To_City" ? true : false}
              />
            </div>
            {FormData?.GSTPaidBy === "Transporter" && e.name === "TaxType" && (
              <div className="freightGST">
                <div>GST%</div>
                {FormData?.TaxType === "IGST" ? (
                  <div>IGST {GSTPercentage}%</div>
                ) : (
                  <div>{`CGST ${(GSTPercentage / 2).toFixed(1)}% - SGST ${(GSTPercentage / 2).toFixed(1)}%`}</div>
                )}
              </div>
            )}
            {FormData?.GSTPaidBy === "Transporter" && e.name === "TaxType" && (
              <div className="freightGST">
                <div>GST</div>
                <div>{Number(((Number(FormData?.Total) * Number(GSTPercentage)) / 100).toFixed(1))}</div>
              </div>
            )}
            {FormData?.GSTPaidBy === "Transporter" && e.name === "Total" && (
              <div className="freightGST">
                <div>Total Amount</div>
                <div>
                  {Math.round(
                    Number(FormData?.Total) +
                    Number(((Number(FormData?.Total) * Number(GSTPercentage)) / 100).toFixed(1))
                  )}
                </div>
              </div>
            )}
          </>
        );
      })}
    </div>
  );
};

export default LRPickupUpdationFreightChargesForm;

{
  /*
  
  import { useFormik } from "formik";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { formikValidation, formikinitialvalues } from "../../../../../CommonFunction/common";
import Input from "../../../Input/Input";
import "./LRPickupUpdationFreightChargesForm.scss";
import { updateFormData } from "../../../../../Store/FormDataReducer/FormFieldFunctions";
import { ErrorToast } from "../../../ToastComponent/RectHotToast";

function getDaysDifference(date1, date2) {
  // Helper function to convert date string from DD/MM/YYYY to Date object
  function parseDate(dateStr) {
    const dateParts = dateStr.split("/").reverse();
    return new Date(dateParts.join("-"));
  }

  const firstDate: any = parseDate(date1);
  const secondDate: any = parseDate(date2);

  // Calculate the difference in time (milliseconds)
  const differenceInTime = secondDate - firstDate;

  // Convert the difference from milliseconds to days
  const differenceInDays = differenceInTime / (1000 * 60 * 60 * 24);

  return Math.abs(differenceInDays + 1); // Return absolute difference to avoid negative values
}

const LRPickupUpdationFreightChargesForm = ({
  inputfields,
  value,
  Type,
  totalWeight,
  totalFreightAmount = 0,
  fielddata,
  handleFreightOnChange,
  TotalKeyName = "Total",
  TypeOfPortal,
  formkey = "",
  formData,
}) => {
  const [fields, setfields] = useState(inputfields);
  const [alldata, setalldata] = useState<any>({});
  const [Value, setValue] = useState(value);
  const FormData = useSelector((store: any) => store.FormDataReducer);
  const dispatch = useDispatch();
  const prevObjRef = useRef();
  console.log(formData, "formData");
  useEffect(() => {
    dispatch({
      type: "Add_FormFieldData",
      payload: { data: alldata, key: Type },
    });
    updateFormData(dispatch, formkey, Type, alldata);
  }, [alldata]);

  useEffect(() => {
    setValue(value);
  }, [value]);

  useEffect(() => {
    if (fielddata) {
      let arr: any = [];
      for (var a = 0; a < fields.length; a++) {
        arr.push({ [fields[a].name]: fielddata[fields[a].name] });
        formik.setFieldValue(fields[a].name, fielddata[fields[a].name]);
      }
      let obj = {};

      for (var l = 0; l < arr.length; l++) {
        let temp = arr[l];
        for (var key in temp) {
          obj[key] = temp[key];
        }
      }

      if (obj) {
        setalldata(obj);
      }
    }
  }, [fielddata]);

  useEffect(() => {
    if (formkey === "FTL_Consignment_Note") {
      if (
        FormData[formkey]?.Consignment_Note_Details?.Outward_Date &&
        FormData[formkey]?.Consignment_Note_Details?.Inward_Date
      ) {
        let remainDays = getDaysDifference(
          FormData[formkey].Consignment_Note_Details.Outward_Date,
          FormData[formkey].Consignment_Note_Details.Inward_Date
        );
        formik.setFieldValue("Trip_Days", remainDays);
      }

      if (
        FormData[formkey]?.Consignment_Note_Details?.Outward_Date &&
        FormData[formkey]?.Consignment_Note_Details?.Inward_Date &&
        FormData[formkey]?.Freight_Charges?.Allow_Days &&
        FormData[formkey]?.Freight_Charges?.Detaintion_Rate
      ) {
        let remainDays = getDaysDifference(
          FormData[formkey].Consignment_Note_Details.Outward_Date,
          FormData[formkey].Consignment_Note_Details.Inward_Date
        );
        if (FormData[formkey]?.Freight_Charges?.Allow_Days < remainDays) {
          let totalDays = remainDays - FormData[formkey]?.Freight_Charges?.Allow_Days;

          let DetaintionAmount = totalDays * FormData[formkey]?.Freight_Charges?.Detaintion_Rate;
          console.log(DetaintionAmount);
          formik.setFieldValue("Detaintion_Amount", DetaintionAmount);
        } else {
          ErrorToast(`Allow Days should be less then ${remainDays}`);
        }
      } else {
        formik.setFieldValue("Detaintion_Amount", "");
      }
    }
  }, [
    FormData[formkey]?.Consignment_Note_Details?.Outward_Date,
    FormData[formkey]?.Consignment_Note_Details?.Inward_Date,
    FormData[formkey]?.Freight_Charges?.Allow_Days,
    FormData[formkey]?.Freight_Charges?.Detaintion_Rate,
  ]);

  

  useEffect(() => {
    if (FormData[formkey]?.Freight_Charges) {
      let obj = FormData[formkey]?.Freight_Charges;
      const prevObj = prevObjRef.current;
      let changedKey = false;
      if (prevObj) {
        for (const key in obj) {
          if (obj[key] !== prevObj[key] && !(Number.isNaN(obj[key]) && Number.isNaN(prevObj[key]))) {
            if (key !== TotalKeyName) {
              changedKey = true;
            }
          }
        }
      }

      if (changedKey) {
        let total = calculateTotal(fields[fields?.length - 1]?.formula);
        formik.setFieldValue(TotalKeyName, Number(total?.toFixed(2)));
      }
      prevObjRef.current = obj;
    }
  }, [FormData[formkey]?.Freight_Charges]);

  useEffect(() => {
    if (formkey !== "Booking_Broker") {
      if (totalWeight) {
        formik.setFieldValue("Total_Weight", totalWeight);
      }
      if (totalFreightAmount) {
        formik.setFieldValue("Freight_Amount", totalFreightAmount?.toFixed(2));
      }
    }
  }, [totalWeight, totalFreightAmount]);

  useEffect(() => {
    if (FormData[formkey] && formkey !== "Booking_Broker") {
      handleFreightOnChange(FormData[formkey]?.Freight_Charges?.Freight_On);

      let total = 0;
      if (FormData[formkey]?.Freight_Charges?.Freight_On === "Weight") {
        total = Number(totalWeight) * Number(FormData[formkey]?.Freight_Charges?.Rate);
      } else if (FormData[formkey]?.Freight_Charges?.Freight_On === "Quantity") {
        total = Number(value) * Number(FormData[formkey]?.Freight_Charges?.Rate);
      } else if (FormData[formkey]?.Freight_Charges?.Freight_On === "Per Box") {
        total = Number(value) * Number(FormData[formkey]?.Freight_Charges?.Rate);
      } else if (FormData[formkey]?.Freight_Charges?.Freight_On === "Per KM") {
        total = Number(FormData[formkey]?.Freight_Charges?.Total_KM) * Number(FormData[formkey]?.Freight_Charges?.Rate);
      } else if (FormData[formkey]?.Freight_Charges?.Freight_On === "Fixed") {
        total = Number(FormData[formkey]?.Freight_Charges?.Rate);
      }

      formik.setFieldValue("Freight_Amount", total ? total.toFixed(2) : 0);
    }
  }, [
    FormData[formkey]?.Freight_Charges?.Freight_On,
    FormData[formkey]?.Freight_Charges?.Rate,
    FormData[formkey]?.Freight_Charges?.Total_KM,
    value,
  ]);

  useEffect(() => {
    if (formkey === "Booking_Broker") {
      // handleFreightOnChange(FormData[formkey]?.Freight_Charges?.Freight_On);

      let total = 0;
      let total1 = 0;
      if (TotalKeyName == "Transporter_Sub_Total") {
        if (FormData[formkey]?.Freight_Charges?.Transporter_Freight_On === "Weight") {
          total1 = Number(totalWeight) * Number(FormData[formkey]?.Freight_Charges?.Transporter_Rate);
        } else if (FormData[formkey]?.Freight_Charges?.Transporter_Freight_On === "Fixed") {
          total1 = Number(FormData[formkey]?.Freight_Charges?.Transporter_Rate);
        }
        formik.setFieldValue("Transporter_Freight_Amount", total1 ? Number(total1.toFixed(2)) : 0);
      } else if (TotalKeyName == "Bill_Party_Sub_Total") {
        if (FormData[formkey]?.Freight_Charges?.Bill_Party_Freight_On === "Weight") {
          total = Number(totalWeight) * Number(FormData[formkey]?.Freight_Charges?.Bill_Party_Rate);
        } else if (FormData[formkey]?.Freight_Charges?.Bill_Party_Freight_On === "Fixed") {
          total = Number(FormData[formkey]?.Freight_Charges?.Bill_Party_Rate);
        }
        formik.setFieldValue("Bill_Party_Freight_Amount", total ? Number(total.toFixed(2)) : 0);
      }
    }
  }, [
    FormData[formkey]?.Freight_Charges?.Transporter_Freight_On,
    FormData[formkey]?.Freight_Charges?.Transporter_Rate,
    FormData[formkey]?.Freight_Charges?.Bill_Party_Freight_On,
    FormData[formkey]?.Freight_Charges?.Bill_Party_Rate,
    totalWeight,
  ]);

  const validate = (values: any) => {
    setalldata({ ...values });
  };

  const formik = useFormik({
    initialValues: () => {
      let initialstate = formikinitialvalues(fields);
      return initialstate;
    },
    validationSchema: formikValidation(fields),
    validate,
    onSubmit: (values) => {},
  });


  
  return (
    <div className="freight-charges-container">
      {fields.map((e, index) => (
        <>
          <div className="freight-charges-input" key={index}>
            <label>{e.label}</label>
            {(e.name === "FOV" || e.name === "FSC") && (
              <>
                <input type="number" className="taxInput" disabled />%
              </>
            )}
            <Input
              EMTQuery=""
              InputConfig={e}
              JurnalDropdown=""
              Section_Type=""
              disabled={e.disabled}
              
              transactions=""
              PaymentProcess=""
              checked=""
              TypeOfPortal={TypeOfPortal}
              name={e.name}
              value={alldata[e.name] === undefined ? "" : alldata[e.name]}
              label={e.label}
              className={"inputwidthAddload"}
              type={e.type}
              modalform={true}
              handleInputChange={(evt) => {
                formik.handleChange(evt);
              }}
              // handelformikdata={handelformikdata}
              dropdowndata={e.dropdowncontent}
              handleBlur={formik.handleBlur}
              touched={formik.touched[e.name]}
              error={formik.errors[e.name]}
              max={e.max ? e.max : undefined}
              notSearchable={e.name === "From_City" || e.name === "To_City" ? true : false}
            />
          </div>
          {e.name === "Total_Weight" &&
            (FormData[formkey]?.Freight_Charges?.Freight_On === "Per Box" ||
              FormData[formkey]?.Freight_Charges?.Freight_On === "Quantity" ||
              FormData[formkey]?.Freight_Charges?.Freight_On === "Per KM") && (
              <div className="freight-charges-input" key={index}>
                <label>
                  {FormData[formkey]?.Freight_Charges?.Freight_On === "Per Box"
                    ? "Total Box"
                    : FormData[formkey]?.Freight_Charges?.Freight_On === "Quantity"
                    ? "Total Quantity"
                    : FormData[formkey]?.Freight_Charges?.Freight_On === "Per KM"
                    ? "Total KM"
                    : ""}
                </label>
                <Input
                  EMTQuery=""
                  InputConfig={e}
                  JurnalDropdown=""
                  Section_Type=""
                  disabled={FormData[formkey]?.Freight_Charges?.Freight_On === "Per KM" ? false : true}
                  
                  transactions=""
                  PaymentProcess=""
                  checked=""
                  TypeOfPortal={TypeOfPortal}
                  name={
                    FormData[formkey]?.Freight_Charges?.Freight_On === "Per Box"
                      ? "Total_Box"
                      : FormData[formkey]?.Freight_Charges?.Freight_On === "Quantity"
                      ? "Total_Quantity"
                      : FormData[formkey]?.Freight_Charges?.Freight_On === "Per KM"
                      ? "Total_KM"
                      : ""
                  }
                  value={Value === 0 ? "" : Value}
                  label={
                    FormData[formkey]?.Freight_Charges?.Freight_On === "Per Box"
                      ? "Total Box"
                      : FormData[formkey]?.Freight_Charges?.Freight_On === "Quantity"
                      ? "Total Quantity"
                      : FormData[formkey]?.Freight_Charges?.Freight_On === "Per KM"
                      ? "Total KM"
                      : ""
                  }
                  className={"inputwidthAddload"}
                  type={e.type}
                  modalform={true}
                  handleInputChange={(evt) => {
                    formik.handleChange(evt);
                  }}
                  // handelformikdata={handelformikdata}
                  dropdowndata={e.dropdowndata}
                  handleBlur={formik.handleBlur}
                  touched={formik.touched[e.name]}
                  error={formik.errors[e.name]}
                  max={e.max ? e.max : undefined}
                  notSearchable={e.name === "From_City" || e.name === "To_City" ? true : false}
                />
              </div>
            )}
        </>
      ))}
    </div>
  );
};

export default LRPickupUpdationFreightChargesForm;

  
  */
}
